import { jsx as _jsx } from "react/jsx-runtime";
import { Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import AppLayout from "@/components/AppLayout";
import AppRouter from "@/components/AppRouter";
import AuthPage from "@/components/AuthPage";
import DeniedPage from "@/components/DeniedPage";
import LazyChunkBoundary from "@/components/LazyChunkBoundary";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/App.module.less";
const CorpApp = React.lazy(() => import("@/components/corp/CorpApp"));
const LoadingScreen = () => (_jsx("div", { className: styles.loadingContainer, children: _jsx(Spin, { size: "large" }) }));
const App = observer(() => {
    const { authStore } = getRootStore();
    useEffect(() => {
        authStore.initializeAuth();
    }, []); // Empty dependency array - only run on mount
    if (authStore.isLoading) {
        return _jsx(LoadingScreen, {});
    }
    if (authStore.principal?.kind === "denied") {
        return _jsx(DeniedPage, {});
    }
    if (!authStore.isAuthenticated) {
        return _jsx(AuthPage, {});
    }
    if (authStore.principal === null) {
        return _jsx(LoadingScreen, {});
    }
    if (authStore.principal.kind === "corp") {
        return (_jsx(LazyChunkBoundary, { children: _jsx(React.Suspense, { fallback: _jsx(LoadingScreen, {}), children: _jsx(CorpApp, {}) }) }));
    }
    return (_jsx("div", { className: styles.app, children: _jsx(AppLayout, { children: _jsx(AppRouter, {}) }) }));
});
export default App;
